<template>
  <div>
    <vx-card>
      <div class="vx-col w-full mb-base">
        <div class="vx-col">
          <h3>Naloži datoteko</h3>

          <vs-upload
            multiple
            ref="upload"
            class="mb-2"
            :show-upload-button="false"
            @on-delete="onFileDelete"
            @change="onFileChange"
            text="Naloži datoteko"
            accept=".xlsx, .xml"
          />

        </div>
      </div>
      <div class="vx-col w-full mb-base">
        <vs-button class="vx-col"
                   @click="checkAndUpload"
                   :disabled="files == null">Naloži
        </vs-button>
      </div>
    </vx-card>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        files: null
      }
    },
    methods: {
      successUpload () {
        this.$vs.notify({
          color: 'success',
          title: 'Upload Success',
          text: 'Lorem ipsum dolor sit amet, consectetur'
        })
      },
      onFileChange () {
        var input = this.$refs.upload
        this.files = input.filesx
        console.log('this.files.length: ' + this.files.length)
        console.log(this.files)
      },
      onFileDelete () {
        this.files = null
      },
      getFileExtension (file) {
        var fname = file.name
        return fname.slice((fname.lastIndexOf('.') - 1 >>> 0) + 2).toLowerCase()
      },
      checkAndUpload () {

        if (this.files == null) {
          alert('you need to select at least one file')
          return
        }

        this.files.forEach(async element => {
          console.log('filename: ' + element.name)
          if (this.getFileExtension(element) == 'xml') {
            await this.uploadFileXml(element)
          } else if (this.getFileExtension(element) == 'xlsx') {
            await this.uploadFileXlsx(element)
          }
        })

      },

      async uploadFileXlsx (file) {
        console.log('file type: xlsx')

        if (file == null) return

        try {
          this.$vs.loading()

          await this.$store.dispatch('data/uploadXlsxFile', {
            file: file
          })

          this.$vs.notify({
            title: 'Uspešno dodano!',
            text: 'Datoteka je bila uspešno dodana!',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })

          setTimeout(() => {
            location.reload()
          }, 800)

        } catch (error) {
          if (error.response.data.error.includes('sheet') && error.response.data.error.includes('is not exist')) {
            this.$vs.notify({
              title: 'Napaka pri nalaganju!',
              text: 'Ime lista v datoteki mora biti enako imenu datoteke',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              time: 5000
            })
          } else {
            this.$vs.notify({
              title: 'Napaka pri nalaganju!',
              text: 'Pri nalaganju datoteke je prišlo do napake',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        } finally {
          this.$vs.loading.close()
        }
      },
      async uploadFileXml (file) {
        console.log('file type: xml')

        if (file == null) return

        try {
          this.$vs.loading()

          await this.$store.dispatch('data/uploadXmlFile', {
            file: file
          })

          this.$vs.notify({
            title: 'Uspešno dodano!',
            text: 'Datoteka je bila uspešno dodana!',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })

          setTimeout(() => {
            location.reload()
          }, 800)

        } catch (error) {

          this.$vs.notify({
            title: 'Napaka pri nalaganju!',
            text: 'Pri nalaganju datoteke je prišlo do napake',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        } finally {
          this.$vs.loading.close()
        }
      }
    }
  }
</script>
